angular.module('app.shared.featuredImage.featuredImageController', [])
  .controller('app.shared.featuredImage.featuredImageController', [
    '$scope',
    '$http',
    'PRODUCT',
    function ($scope, $http, product) {
      "use strict";

      $scope.featuredImage = null;

      let init = function () {
        getRandomFeaturedImage();
      };

      let getRandomFeaturedImage = function () {
        if (!product.StorageBucket) {
          console.error("Missing product StorageBucket config");
          setDefaultFeaturedImage();
          return;
        }

        return $http.get(product.StorageBucket + '/homepage/featured/featured.json')
          .then(
            function (response) {
              let data = response.data;

              if (data && Array.isArray(data.images)) {
                let numImages = data.images.length;
                let randNum = Math.floor(Math.random() * numImages);

                $scope.featuredImage = data.images[randNum];
              }
              else {
                setDefaultFeaturedImage();
              }
            },
            /**
             * @param {HttpResponse} response
             */
            function (data) {
              // error.. set the default
              setDefaultFeaturedImage();
            }
          );
      };

      let setDefaultFeaturedImage = function() {
        $scope.featuredImage = '/assets/images/ahl/featured/head-image-1.jpg';
      };

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/featuredImage/featuredImageController.js